import { Injectable } from '@angular/core';
import { LuxonDateAdapter } from '@angular/material-luxon-adapter';
import { DateTimeOptions } from 'luxon';
import { EDITION_TIME_ZONE } from './course-edition.utils';

/** Shape of the (TypeScript-private) options factory every `LuxonDateAdapter` method builds its `DateTime`s with. */
interface LuxonOptionsFactory {
  _getOptions: () => DateTimeOptions;
}

/**
 * ENF-2372 (A.3, QA-A-03) — `LuxonDateAdapter` fixed to Madrid for the purchase-validity pickers.
 *
 * The app-wide adapter builds dates in the browser's zone, so a Madrid time that does not exist there (e.g.
 * 14/03/2027 02:30 in New York) was normalised one hour before it ever reached the conversion to UTC. With this
 * adapter the calendar, the hour spinners and the text the input parses all create `DateTime`s directly in
 * `Europe/Madrid`, and a stored instant is painted with its Madrid time, wherever the admin is.
 *
 * `LuxonDateAdapter` exposes no zone option (only `useUtc`), but every method that creates a `DateTime` reads its
 * zone from `_getOptions()`; the instance override below adds the zone to it. The spec pins this behaviour, so a
 * Material upgrade that changes it fails there instead of silently going back to the browser's zone.
 *
 * Provided by `CourseEditionFieldsComponent` (element injector): only its two pickers use it.
 */
@Injectable()
export class EditionDateAdapter extends LuxonDateAdapter {
  constructor() {
    super();
    const adapter = this as unknown as LuxonOptionsFactory;
    const baseOptions = adapter._getOptions.bind(this);
    adapter._getOptions = () => ({ ...baseOptions(), zone: EDITION_TIME_ZONE });
  }
}
